export enum PettyCashStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export class PettyCash {
  pettyCashId: number; // rk
  businessId: string; // hk
  name: string;
  siteId: number;
  userId: string;
  accountId: string;
  balance: number;
  status: PettyCashStatus;
  createdAt: number;
  lastModifiedAt: number;
  createdBy: string;
  lastModifiedBy: string;
}

export enum PettyCashItemStatus {
  Approved = 'Approved',
  Declined = 'Declined',
  Pending = 'Pending',
}

export class PettyCashItem {
  pettyCashItemId: number; // rk
  pettyCashId: number; // hk
  businessId: string; // hk
  name: string;
  siteId: number;
  userId: string;
  amount: number;
  notes?: string;
  type?: 'Withdrawal' | 'Deposit';
  status: PettyCashItemStatus;
  approvedBy?: string;
  approvedAt?: number;
  createdAt: number;
  lastModifiedAt: number;
  createdBy: string;
  lastModifiedBy: string;
}
